function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "no_bell"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m21.707 20.293-18-18c-.391-.391-1.023-.391-1.414 0s-.391 1.023 0 1.414l3.893 3.893c-.111.451-.186.915-.186 1.4v4.171c-1.164.413-2 1.525-2 2.829v2c0 .553.447 1 1 1h12.586l2.707 2.707c.195.195.451.293.707.293s.512-.098.707-.293c.391-.391.391-1.023 0-1.414zm-15.707-3.293v-1c0-.552.448-1 1-1 .553 0 1-.447 1-1v-4.586l7.586 7.586z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m10.093 5.486c.586-.322 1.228-.486 1.907-.486 2.206 0 4 1.794 4 4v3c0 .553.447 1 1 1s1-.447 1-1v-3c0-2.967-2.167-5.432-5-5.91v-.09c0-.553-.447-1-1-1s-1 .447-1 1v.093c-.653.109-1.282.317-1.872.641-.483.266-.66.874-.394 1.359.266.484.874.658 1.359.393z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m13 20h-2c-.553 0-1 .447-1 1s.447 1 1 1h2c.553 0 1-.447 1-1s-.447-1-1-1z"
})));

var Svg068Bell = function Svg068Bell(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg068Bell, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/068-bell.b1b5cbb2.svg";
export { ForwardRef as ReactComponent };